import script from "./Video.vue?vue&type=script&setup=true&lang=ts"
export * from "./Video.vue?vue&type=script&setup=true&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=fdfe2d0a&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdfe2d0a"]])

export default __exports__